import * as UserApi from './';
import { BaseEntity } from '../../core/BaseEntity';

export class Classification extends BaseEntity {
  Name: string;
  //Permissions: UserApi.Permission[] = [];
}
